import { RouteRecordRaw } from 'vue-router';
import { StartSettingsRoute } from 'src/router/startSetting';
import { Accounts } from 'src/router/accounts';
import { Groups } from 'src/router/groups';
import { GroupTypes } from 'src/router/groupTypes';
import { ResourceTypes } from 'src/router/resourceTypes';
import { Resources } from 'src/router/resources';
import { GroupResources } from 'src/router/groupResources';
import { Events } from 'src/router/events';
import { Incidents } from 'src/router/incidents';
import { Enquetes } from 'src/router/enquetes';
import { EnqueteTemplates } from 'src/router/enqueteTemplates';
import { QuestionTemplates } from 'src/router/questionTemplates';
import { MailTemplates } from 'src/router/mailTemplates';
import { Trees } from 'src/router/trees';
import { MyPage } from 'src/router/mypage';
import { Bulk } from 'src/router/bulk';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    meta: { requiresAuth: true },
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        name: 'index',
        path: '',
        component: () => import('pages/IndexPage.vue'),
      },
    ],
  },
  Accounts,
  Groups,
  GroupTypes,
  ResourceTypes,
  Resources,
  GroupResources,
  Trees,
  Events,
  Incidents,
  Enquetes,
  EnqueteTemplates,
  QuestionTemplates,
  MailTemplates,
  StartSettingsRoute,
  MyPage,
  Bulk,
  {
    path: '/form',
    meta: { requiresAuth: true },
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', name: 'form', component: () => import('pages/FormPage.vue') },
    ],
  },
  {
    path: '/forms',
    meta: { requiresAuth: true },
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: 'create', component: () => import('pages/forms/CreatePage.vue') },
    ],
  },
  {
    path: '/login',
    component: () => import('layouts/LoginLayout.vue'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('pages/LoginPage.vue'),
        meta: {
          title: 'ログイン',
        },
      },
    ],
  },
  {
    path: '/e',
    component: () => import('layouts/LoginLayout.vue'),
    children: [
      {
        path: '',
        name: 'preEmailLogin',
        component: () => import('pages/PreEmailLoginPage.vue'),
        meta: {
          title: 'メールログイン',
        },
      },
    ],
  },
  {
    path: '/email-login',
    component: () => import('layouts/LoginLayout.vue'),
    children: [
      {
        path: '',
        name: 'emailLogin',
        component: () => import('pages/EmailLoginPage.vue'),
        meta: {
          title: 'メールログイン',
        },
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
